var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokMobileShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 27,
  viewBox: "0 0 35 27",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M33.868 14.694Q21.078 26.5 19.62 26.5c-1 0-1-2.395-1-2.754V20.5q-6.5-.5-11.5 1c-5 1.5-5.5 5-6.29 5-.792 0-1.11-4.872-.536-6.65l.546-1.637C2.698 12.814 8.119 5.66 18.619 6.5V2.613c0-.361 0-2.613 1-2.613q1.46 0 14.29 13.264a1 1 0 0 1-.04 1.43"
})));
export default SvgTiktokMobileShare;